import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import assets from 'modules/assets'

class ArchiveBottom extends Component {
  render() {
    let video
    switch (this.props.year) {
      case 2015:
        video = <iframe src="https://player.vimeo.com/video/139308564?color=b10000&title=0&byline=0&portrait=0" width="640" frameBorder="0" allowFullScreen></iframe>
        break
      case 2014:
        video = <iframe src="https://player.vimeo.com/video/107012635?color=b10000&title=0&byline=0&portrait=0" width="640" frameBorder="0" allowFullScreen></iframe>
        break
      case 2013:
        video = <iframe src="https://player.vimeo.com/video/72023315?color=b10000&title=0&byline=0&portrait=0" width="640" frameBorder="0" allowFullScreen></iframe>
        break
      case 2012:
        video = <iframe src="https://player.vimeo.com/video/84266621?color=b10000&title=0&byline=0&portrait=0" width="640" frameBorder="0" allowFullScreen></iframe>
        break
    }
    return (
      <div className="archive-main">
        <div className="main-grid">
          <ul className="grid group">
            <div className="iframe-wrapper">
              {video}
            </div>

          </ul>
        </div>
    </div>
    )
  }
}

ArchiveBottom.contextTypes = {
}
ArchiveBottom.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(ArchiveBottom)



// WEBPACK FOOTER //
// ./src/components/Archive/ArchiveBottom.js